import React, { Component } from 'react';
import PropTypes from 'prop-types';
import groupBy from 'lodash/groupBy';
import Half from '../../components/Half';
import plusWhite from '../../assets/images/plus-white.svg';
import circleGreen from '../../assets/images/circle-green.svg';
import circleRight from '../../assets/images/circle-right.svg';
import tick from '../../assets/images/tick.svg';

class HalfBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      itemVariants: [],
      hhActiveMenuSizes: [],
      clicked: 0,
      flag: false,
    };
  }

  componentDidMount = () => {
    if (this.props.halfItem && this.props.menuItems) {
      this.getSizeAvailability(this.props.menuItems, this.props.halfItem);
      this.showVariants(this.props.menuItems, this.props.halfItem);
    }
  };

  componentWillReceiveProps(props) {
    if (props.halfItem && props.items) {
      this.getSizeAvailability(props.items, props.halfItem);
    }
    if (
      this.props.selectedHalfItems.length >= 2 &&
      props.selectedHalfItems[1] &&
      this.props.selectedHalfItems[1]._id !== props.selectedHalfItems[1]._id
    )
      this.setState({ flag: false });
  }

  showVariants = (menuItems, halfItem) => {
    if (halfItem.categories) {
      let matchingMenuItems = menuItems.filter((menuItem) => {
        return halfItem.categories
          .map((m) => m._id)
          .includes(menuItem.categoryId);
      });
      let itemVariants = [];
      if (halfItem.selectedSizes) {
        halfItem.selectedSizes.forEach((size) => {
          matchingMenuItems.forEach((menuItem) => {
            menuItem.selectedSizes.forEach((s) => {
              if (size._id === s._id) {
                if (s.variants) {
                  s.variants.map((v) => {
                    if (v.isSelected) {
                      let matchingVariants = itemVariants.filter((ss) => {
                        return ss._id === v._id;
                      });
                      if (matchingVariants.length <= 0) itemVariants.push(v);
                    }
                  });
                }
              }
            });
          });
        });
        itemVariants.map((v) => {
          v.isClicked = false;
          return v;
        });
        this.setState({ itemVariants });
      }
    }
  };

  defaultFilter = () => {
    this.props.halfFilter(
      this.props.whichHalf,
      this.state.itemVariants.filter((f) => f.isClicked),
      this.state.hhActiveMenuSizes
    );
  };

  getImageUrl = (whichHalf, flag) => {
    if (this.props.selectedHalfItems) {
      let halfTms = this.props.selectedHalfItems[whichHalf];
      let prevTms = this.props.selectedHalfItems[whichHalf - 1];
      if (halfTms) {
        var sectionStyle = {
          backgroundImage: `url(${halfTms.urlS3})`,
        };
        return (
          <div className='halfHalfwImage' style={sectionStyle}>
            <span>{halfTms.name}</span>
            <div className='faded' />
          </div>
        );
      } else {
        if (prevTms || (whichHalf === 1 && flag === true)) {
          return (
            <div>
              <span>
                <img src={plusWhite} alt='' />
                Add
              </span>
              <img src={circleGreen} alt='' />
            </div>
          );
        } else {
          return (
            <div>
              <span>
                <img src={plusWhite} alt='' />
                Add
              </span>
              <img src={circleRight} alt='' />
            </div>
          );
        }
      }
    } else {
      if (flag === true)
        return (
          <div>
            <span>
              <img src={plusWhite} alt='' />
              Add
            </span>
            <img src={circleGreen} alt='' />
          </div>
        );
      else
        return (
          <div>
            <span>
              <img src={plusWhite} alt='' />
              Add
            </span>
            <img src={circleRight} alt='' />
          </div>
        );
    }
  };

  isSubmitEnabled = () => {
    if (
      this.props.selectedHalfItems &&
      this.props.selectedHalfItems.length >= 2
    ) {
      return true;
    } else {
      return false;
    }
  };

  callFilter = (item) => {
    let halfItem = JSON.parse(JSON.stringify(this.state.halfItem));
    let pairId = '-1';
    let hhActiveMenuSizes = [];
    halfItem.selectedSizes &&
      halfItem.selectedSizes.map((s) => {
        if (s.isAvailable && item._id === s._id) {
          pairId = item.pairId;
          hhActiveMenuSizes.push(s);
        }
        return s;
      });
    halfItem.selectedModifiers &&
      halfItem.selectedModifiers.map((s) => {
        if (s.isAvailable && item._id === s._id) {
          pairId = item.pairId;
          hhActiveMenuSizes.push(s);
        }
        return s;
      });
    if (halfItem.categories.length > 1) {
      halfItem.selectedSizes.map((s) => {
        if (
          s.isAvailable &&
          s.pairId === pairId &&
          !hhActiveMenuSizes.map((h) => h._id).includes(s._id)
        ) {
          hhActiveMenuSizes.push(s);
        }
        return s;
      });
      halfItem.selectedModifiers.map((s) => {
        if (
          s.isAvailable &&
          s.pairId === pairId &&
          !hhActiveMenuSizes.map((h) => h._id).includes(s._id)
        ) {
          hhActiveMenuSizes.push(s);
        }
        return s;
      });
    }

    this.setState({ hhActiveMenuSizes }, () => {
      this.props.clearOrChangeSize(
        this.state.hhActiveMenuSizes,
        this.state.itemVariants.filter((f) => f.isClicked)
      );
      if (
        window.innerWidth > 991 &&
        !(
          window.navigator.userAgent.match(/iPad/i) && window.innerHeight > 1250
        )
      )
        this.defaultFilter();
    });
  };

  filterIt = (whichHalf, flag) => {
    this.setState({ clicked: whichHalf, flag }, () => {
      this.props.halfFilter(
        whichHalf,
        this.state.itemVariants.filter((f) => f.isClicked),
        this.state.hhActiveMenuSizes
      );
    });
  };

  addHalfHalfToOrder = () => {
    if (this.isSubmitEnabled()) {
      this.props.addHalfHalfToOrder();
    }
  };

  toggleVariant = (variant) => {
    let itemVariants = JSON.parse(JSON.stringify(this.state.itemVariants));
    itemVariants.map((v) => {
      if (v._id === variant._id) v.isClicked = !v.isClicked;
      return v;
    });
    this.setState(
      {
        itemVariants,
      },
      () => {
        this.props.clearItemsNotAvailableForVariants(
          itemVariants.filter((f) => f.isClicked)
        );
        this.getSizeAvailability(this.props.menuItems, this.props.halfItem);
        if (this.state.clicked > 0) this.defaultFilter();
      }
    );
  };

  getSizeAvailability = (itemObjs, halfItemObj) => {
    let menuItems = JSON.parse(JSON.stringify(itemObjs));
    let halfItem = JSON.parse(JSON.stringify(halfItemObj));
    let hhActiveMenuSizes = [];
    let pairId = '-1';

    if (halfItem.selectedSizes) {
      halfItem.selectedSizes.map((size) => {
        let matchingMenuItems = menuItems.filter((m) => {
          return halfItem.categories.map((m) => m._id).includes(m.categoryId);
        });
        let count = 0;
        if (matchingMenuItems.length > 0) {
          matchingMenuItems.map((m) => {
            if (m.selectedSizes) {
              m.selectedSizes.map((s) => {
                if (
                  this.state.itemVariants &&
                  this.state.itemVariants.filter((f) => f.isClicked).length > 0
                ) {
                  let cnt = 0;
                  if (s.variants) {
                    const matchingVariants = s.variants.filter((v) => {
                      return (
                        v.isSelected &&
                        v.isAvailable &&
                        this.state.itemVariants
                          .filter((f) => f.isClicked)
                          .map((m) => m._id)
                          .includes(v._id)
                      );
                    });

                    cnt = matchingVariants.length;

                    if (
                      s._id === size._id &&
                      cnt ===
                        this.state.itemVariants.filter((f) => f.isClicked)
                          .length
                    )
                      count = count + 1;
                  }
                } else {
                  if (s._id === size._id) count = count + 1;
                }
                return s;
              });
            }
            return m;
          });
          if (count > 0) size.isAvailable = true;
          else size.isAvailable = false;
        } else {
          size.isAvailable = false;
        }
        return size;
      });

      halfItem.selectedSizes.map((s) => {
        if (
          s.isAvailable &&
          (halfItem.defaultSizes.map((m) => m._id).includes(s._id) ||
            s.pairId === pairId)
        ) {
          pairId = s.pairId;
          hhActiveMenuSizes.push(s);
        }
        return s;
      });
      if (halfItem.categories.length > 1) {
        halfItem.selectedSizes.map((s) => {
          if (
            s.isAvailable &&
            s.pairId === pairId &&
            !this.state.hhActiveMenuSizes.map((h) => h._id).includes(s._id)
          )
            hhActiveMenuSizes.push(s);
        });
      }
    }
    if (halfItem.selectedModifiers) {
      halfItem.selectedModifiers.map((size) => {
        let matchingMenuItems = menuItems.filter((m) => {
          return halfItem.categories.map((m) => m._id).includes(m.categoryId);
        });
        let count = 0;
        if (matchingMenuItems.length > 0) {
          matchingMenuItems.map((m) => {
            if (m.selectedSizes) {
              m.selectedSizes.map((s) => {
                if (
                  this.state.itemVariants &&
                  this.state.itemVariants.filter((f) => f.isClicked).length > 0
                ) {
                  let cnt = 0;
                  if (s.variants) {
                    s.variants.map((v) => {
                      if (
                        v.isSelected &&
                        this.state.itemVariants
                          .filter((f) => f.isClicked)
                          .map((m) => m._id)
                          .includes(v._id)
                      )
                        cnt = cnt + 1;
                      return v;
                    });
                    if (
                      s._id === size._id &&
                      cnt ===
                        this.state.itemVariants.filter((f) => f.isClicked)
                          .length
                    )
                      count = count + 1;
                  }
                } else {
                  if (s._id === size._id) count = count + 1;
                }
                return s;
              });
            }
            return m;
          });
          if (count > 0) size.isAvailable = true;
          else size.isAvailable = false;
        } else {
          size.isAvailable = false;
        }
        return size;
      });

      halfItem.selectedModifiers.map((s) => {
        if (
          s.isAvailable &&
          (halfItem.defaultSizes.findIndex((m) => m._id === s._id) !== -1 ||
            s.pairId === pairId)
        ) {
          pairId = s.pairId;
          hhActiveMenuSizes.push(s);
        }
        return s;
      });
      if (halfItem.categories.length > 1) {
        halfItem.selectedModifiers.map((s) => {
          if (
            s.isAvailable &&
            s.pairId === pairId &&
            !this.state.hhActiveMenuSizes.map((h) => h._id).includes(s._id)
          ) {
            hhActiveMenuSizes.push(s);
          }
          return s;
        });
      }
    }

    if (halfItem.defaultSizes && !this.state.hhActiveMenuSizes) {
      hhActiveMenuSizes = halfItem.defaultSizes.reduce(
        (acc, s) => [
          ...acc,
          ...halfItem.selectedSizes.filter((ss) => ss.pairId === s.pairId),
          ...halfItem.selectedModifiers.filter((sm) => sm.pairId === s.pairId),
        ],
        []
      );
    }

    this.setState({ halfItem, hhActiveMenuSizes }, () => {
      if (
        window.innerWidth > 991 &&
        !(
          window.navigator.userAgent.match(/iPad/i) && window.innerHeight > 1250
        )
      ) {
        this.setState({ clicked: 1 });
        this.defaultFilter();
      }
    });
  };

  render() {
    const { halfItem, hhActiveMenuSizes } = this.state;
    let sizeList = [];
    if (halfItem && halfItem.selectedSizes !== undefined) {
      halfItem.selectedSizes
        .filter((f) => f.isAvailable)
        .map((m) => {
          sizeList.push(m);
          return m;
        });
    }
    if (halfItem && halfItem.selectedModifiers !== undefined) {
      halfItem.selectedModifiers
        .filter((f) => f.isAvailable)
        .map((m) => {
          sizeList.push(m);
          return m;
        });
    }
    sizeList = groupBy(sizeList, (s) => s.pairId);
    return (
      <div className='specialViewI'>
        <div
          className='detailsTitle sP half'
          style={{
            marginTop: 0,
            justifyContent: 'space-between',
            paddingRight: 0,
          }}
        >
          <strong>Half / Half</strong>
          <div style={{ display: 'flex', flexFlow: 'row nowrap' }}>
            {this.state.itemVariants &&
              this.state.itemVariants.length > 0 &&
              this.state.itemVariants.map((v, index) => (
                <span
                  key={v._id}
                  onClick={() => this.toggleVariant(v)}
                  className='voucher'
                >
                  {v.isClicked ? (
                    <img src={tick} alt='' className='tick' />
                  ) : (
                    <img src={plusWhite} alt='' />
                  )}
                  <span
                    style={{
                      margin: 0,
                      padding: 0,
                      paddingRight: 10,
                      lineHeight: '1em',
                      fontSize: '1em',
                    }}
                  >
                    {v.name}
                  </span>
                </span>
              ))}
          </div>
        </div>
        <div className='halfDivs'>
          <Half
            flag={false}
            itemObj={
              this.props?.selectedHalfItems?.filter(
                (hItem) => hItem.whichHalf === 1
              )[0] || {}
            }
            selectedHalfItems={this.props.selectedHalfItems}
            clickHandler={this.filterIt}
            myID={1}
            currentClicked={this.state.clicked}
            key={1}
          />
          <Half
            flag={this.state.flag}
            itemObj={
              this.props?.selectedHalfItems?.filter(
                (hItem) => hItem.whichHalf === 2
              )[0] || {}
            }
            selectedHalfItems={this.props.selectedHalfItems}
            clickHandler={this.filterIt}
            myID={2}
            currentClicked={this.state.clicked}
            key={2}
          />
        </div>
        <div className='selectSizes'>
          <span className='viewTitle'>Select Size</span>
          <hr style={{ marginTop: -15 }} />
          <div className='sizesI'>
            {Object.keys(sizeList).map((pairId, index) => {
              const item = sizeList[pairId][0];
              const isSelected =
                hhActiveMenuSizes.findIndex((s) => s.pairId === pairId) !== -1;

              return (
                item.isAvailable && (
                  <div
                    key={index}
                    className={isSelected ? 'default' : ''}
                    onClick={() => this.callFilter(item)}
                  >
                    {item.name}
                  </div>
                )
              );
            })}
          </div>
          <div className='addToHalf'>
            <div
              onClick={() => this.addHalfHalfToOrder()}
              className={
                this.isSubmitEnabled()
                  ? 'confirmBtn'
                  : 'confirmBtn diableConfirm'
              }
            >
              Add to Order
            </div>
          </div>
        </div>
      </div>
    );
  }
}

HalfBox.propTypes = {
  halfItem: PropTypes.any,
  selectedHalfItems: PropTypes.any,
  halfFilter: PropTypes.any,
  addHalfHalfToOrder: PropTypes.any,
  clearItemsNotAvailableForVariants: PropTypes.any,
  whichHalf: PropTypes.any,
  menuItems: PropTypes.any,
  clearOrChangeSize: PropTypes.any,
};

export default HalfBox;
